<template>
  <div class="bar-chart" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getPositionCompletionRate } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";

export default {
  name: 'BarChart',
  inject: ['parentThat'],
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    // 初始化图表
    this.chart = echarts.init(this.$refs.chartRef)
    this.init()

    // 监听窗口大小变化，实现自适应
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    // 组件销毁时移除事件监听，避免内存泄漏
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    init () {
      const { queryForm } = this.parentThat
      getPositionCompletionRate(queryForm).then(({ data }) => {
        const dataAll = extractTitleAndValueArrays(data.data, 'teamName', 'completionRate')
        this.setChartOption( dataAll.values, dataAll.titles)
      })
    },
    setChartOption (data,title) {
      const option = {
        title: {
          text: '岗位完成率排名',
          left: '10%',
          top: '5%'
        },
        xAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        yAxis: {
          type: 'category',
          data: title,
          inverse: true // 让数据从上到下排列
        },
        series: [
          {
            type: 'bar',
            data: data,
            itemStyle: {
              color: '#4895ef'
            },
            label: {
              show: true,
              position: 'right',
              formatter: '{c}%'
            },
            barWidth: '60%'
          }
        ],
        grid: {
          left: '15%',
          right: '10%',
          top: '20%',
          bottom: '10%'
        }
      }
      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>
